interface VoucherSectionProps {
  onCourseVoucherSelect: (code: string) => void;
  onCarVoucherSelect: (code: string) => void;
}

export default function VoucherSection({ onCourseVoucherSelect, onCarVoucherSelect }: VoucherSectionProps) {
  const copyToClipboard = (code: string) => {
    navigator.clipboard.writeText(code);
    alert(`Đã sao chép mã: ${code}`);
  };

  const handleVoucherClick = (code: string, formId: string, isCarVoucher: boolean) => {
    if (isCarVoucher) {
      onCarVoucherSelect(code);
    } else {
      onCourseVoucherSelect(code);
    }
    
    // Scroll to form
    setTimeout(() => {
      const formElement = document.getElementById(formId);
      if (formElement) {
        formElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };

  return (
    <section className="py-20 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">Mã Giảm Giá Đặc Biệt</h2>
          <p className="text-xl text-gray-600">Quét mã QR hoặc click để áp dụng voucher ngay</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {/* Course Vouchers */}
          <div className="space-y-5">
            <h3 className="text-2xl font-bold text-gray-800 mb-4 flex items-center gap-2">
              <i className="ri-graduation-cap-fill text-blue-600"></i>
              Khóa Học Robotics
            </h3>

            {/* ERB-30 */}
            <div 
              onClick={() => handleVoucherClick('ERB-30', 'course-form', false)}
              className="relative bg-gradient-to-br from-blue-600 to-blue-400 rounded-3xl p-8 shadow-xl overflow-hidden group hover:scale-105 transition-transform cursor-pointer"
            >
              <div className="absolute top-4 right-4 w-20 h-20 flex items-center justify-center">
                <i className="ri-robot-2-line text-7xl text-white/20"></i>
              </div>
              
              <div className="relative z-10">
                <p className="text-sm uppercase tracking-wider text-white/80 mb-2">Khóa Học Robotics</p>
                <div className="flex items-end gap-2 mb-2">
                  <span className="text-7xl font-bold text-yellow-300">30%</span>
                  <span className="text-2xl font-semibold text-white mb-2">GIẢM GIÁ</span>
                </div>
                
                <div className="mt-6 grid grid-cols-2 gap-4">
                  {/* QR Code */}
                  <div className="bg-white rounded-xl p-3 flex flex-col items-center">
                    <img 
                      src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(window.location.origin + '/robotics-register?voucher=ERB-30&type=course')}`}
                      alt="QR Code ERB-30"
                      className="w-full h-auto"
                    />
                    <p className="text-xs text-gray-600 mt-2 text-center">Quét để đăng ký</p>
                  </div>
                  
                  {/* Voucher Code */}
                  <div className="flex flex-col justify-center">
                    <div className="bg-black/30 backdrop-blur-sm rounded-xl px-4 py-3 flex items-center justify-between mb-3">
                      <span className="font-mono text-lg font-bold text-white tracking-wider">ERB-30</span>
                      <button 
                        onClick={(e) => {
                          e.stopPropagation();
                          copyToClipboard('ERB-30');
                        }}
                        className="w-8 h-8 flex items-center justify-center hover:bg-white/20 rounded-lg transition-colors cursor-pointer"
                      >
                        <i className="ri-file-copy-line text-white/70"></i>
                      </button>
                    </div>
                    <p className="text-xs text-white/80 text-center">Click để áp dụng</p>
                  </div>
                </div>
              </div>
            </div>

            {/* ERB-20 */}
            <div 
              onClick={() => handleVoucherClick('ERB-20', 'course-form', false)}
              className="relative bg-gradient-to-br from-cyan-500 to-teal-400 rounded-3xl p-8 shadow-xl overflow-hidden group hover:scale-105 transition-transform cursor-pointer"
            >
              <div className="absolute top-4 right-4 w-20 h-20 flex items-center justify-center">
                <i className="ri-robot-2-line text-7xl text-white/20"></i>
              </div>
              
              <div className="relative z-10">
                <p className="text-sm uppercase tracking-wider text-white/80 mb-2">Khóa Học Robotics</p>
                <div className="flex items-end gap-2 mb-2">
                  <span className="text-7xl font-bold text-emerald-300">20%</span>
                  <span className="text-2xl font-semibold text-white mb-2">GIẢM GIÁ</span>
                </div>
                
                <div className="mt-6 grid grid-cols-2 gap-4">
                  {/* QR Code */}
                  <div className="bg-white rounded-xl p-3 flex flex-col items-center">
                    <img 
                      src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(window.location.origin + '/robotics-register?voucher=ERB-20&type=course')}`}
                      alt="QR Code ERB-20"
                      className="w-full h-auto"
                    />
                    <p className="text-xs text-gray-600 mt-2 text-center">Quét để đăng ký</p>
                  </div>
                  
                  {/* Voucher Code */}
                  <div className="flex flex-col justify-center">
                    <div className="bg-black/30 backdrop-blur-sm rounded-xl px-4 py-3 flex items-center justify-between mb-3">
                      <span className="font-mono text-lg font-bold text-white tracking-wider">ERB-20</span>
                      <button 
                        onClick={(e) => {
                          e.stopPropagation();
                          copyToClipboard('ERB-20');
                        }}
                        className="w-8 h-8 flex items-center justify-center hover:bg-white/20 rounded-lg transition-colors cursor-pointer"
                      >
                        <i className="ri-file-copy-line text-white/70"></i>
                      </button>
                    </div>
                    <p className="text-xs text-white/80 text-center">Click để áp dụng</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Smart Car Vouchers */}
          <div className="space-y-5">
            <h3 className="text-2xl font-bold text-gray-800 mb-4 flex items-center gap-2">
              <i className="ri-car-fill text-orange-600"></i>
              Smart Car Robotics
            </h3>

            {/* RBSC-30 */}
            <div 
              onClick={() => handleVoucherClick('RBSC-30', 'car-form', true)}
              className="relative bg-gradient-to-br from-orange-600 to-red-500 rounded-3xl p-8 shadow-xl overflow-hidden group hover:scale-105 transition-transform cursor-pointer"
            >
              <div className="absolute top-4 right-4 w-20 h-20 flex items-center justify-center">
                <i className="ri-car-fill text-7xl text-white/20"></i>
              </div>
              
              <div className="relative z-10">
                <p className="text-sm uppercase tracking-wider text-white/80 mb-2">Smart Car Robotics</p>
                <div className="flex items-end gap-2 mb-2">
                  <span className="text-7xl font-bold text-yellow-300">30%</span>
                  <span className="text-2xl font-semibold text-white mb-2">GIẢM GIÁ</span>
                </div>
                
                <div className="mt-6 grid grid-cols-2 gap-4">
                  {/* QR Code */}
                  <div className="bg-white rounded-xl p-3 flex flex-col items-center">
                    <img 
                      src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(window.location.origin + '/robotics-register?voucher=RBSC-30&type=car')}`}
                      alt="QR Code RBSC-30"
                      className="w-full h-auto"
                    />
                    <p className="text-xs text-gray-600 mt-2 text-center">Quét để đặt hàng</p>
                  </div>
                  
                  {/* Voucher Code */}
                  <div className="flex flex-col justify-center">
                    <div className="bg-black/30 backdrop-blur-sm rounded-xl px-4 py-3 flex items-center justify-between mb-3">
                      <span className="font-mono text-lg font-bold text-white tracking-wider">RBSC-30</span>
                      <button 
                        onClick={(e) => {
                          e.stopPropagation();
                          copyToClipboard('RBSC-30');
                        }}
                        className="w-8 h-8 flex items-center justify-center hover:bg-white/20 rounded-lg transition-colors cursor-pointer"
                      >
                        <i className="ri-file-copy-line text-white/70"></i>
                      </button>
                    </div>
                    <p className="text-xs text-white/80 text-center">Click để áp dụng</p>
                  </div>
                </div>
              </div>
            </div>

            {/* RBSC-20 */}
            <div 
              onClick={() => handleVoucherClick('RBSC-20', 'car-form', true)}
              className="relative bg-gradient-to-br from-pink-500 to-rose-400 rounded-3xl p-8 shadow-xl overflow-hidden group hover:scale-105 transition-transform cursor-pointer"
            >
              <div className="absolute top-4 right-4 w-20 h-20 flex items-center justify-center">
                <i className="ri-car-fill text-7xl text-white/20"></i>
              </div>
              
              <div className="relative z-10">
                <p className="text-sm uppercase tracking-wider text-white/80 mb-2">Smart Car Robotics</p>
                <div className="flex items-end gap-2 mb-2">
                  <span className="text-7xl font-bold text-yellow-300">20%</span>
                  <span className="text-2xl font-semibold text-white mb-2">GIẢM GIÁ</span>
                </div>
                
                <div className="mt-6 grid grid-cols-2 gap-4">
                  {/* QR Code */}
                  <div className="bg-white rounded-xl p-3 flex flex-col items-center">
                    <img 
                      src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(window.location.origin + '/robotics-register?voucher=RBSC-20&type=car')}`}
                      alt="QR Code RBSC-20"
                      className="w-full h-auto"
                    />
                    <p className="text-xs text-gray-600 mt-2 text-center">Quét để đặt hàng</p>
                  </div>
                  
                  {/* Voucher Code */}
                  <div className="flex flex-col justify-center">
                    <div className="bg-black/30 backdrop-blur-sm rounded-xl px-4 py-3 flex items-center justify-between mb-3">
                      <span className="font-mono text-lg font-bold text-white tracking-wider">RBSC-20</span>
                      <button 
                        onClick={(e) => {
                          e.stopPropagation();
                          copyToClipboard('RBSC-20');
                        }}
                        className="w-8 h-8 flex items-center justify-center hover:bg-white/20 rounded-lg transition-colors cursor-pointer"
                      >
                        <i className="ri-file-copy-line text-white/70"></i>
                      </button>
                    </div>
                    <p className="text-xs text-white/80 text-center">Click để áp dụng</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}